import { BaseModel } from '../../_base/crud';

export class RoleTemplate extends BaseModel {
  id: number;
  title: string;
  is_active: boolean;
  permissions: number[];

  clear(): void {
    this.id = 0;
    this.title = '';
    this.is_active = true;
    this.permissions = [];
  }
}
